import { CellFormatOptions, ColumnTable, Table } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../../../../../../components/text/SectionTitle';
import TableEmptyContent from '../../../../../../components/text/TableEmptyContent';
import { MainStudy } from '../../types';
import { formatDate } from '../../../../../../utils/dates';

interface MainStudiesProps {
  mainStudiesData: MainStudy[];
}

export const MainStudies = ({ mainStudiesData }: MainStudiesProps) => {
  const { t } = useTranslation();

  const texts = useMemo(() => {
    const prefix = 'studentManagement.educationalInformation';
    return {
      title: t(`${prefix}.title`),
      noRecords: t(`${prefix}.emptyContent.title`),
      noRecordsSubtitle: t(`${prefix}.emptyContent.subtitle`),
      columns: {
        academicLevel: t(`${prefix}.columns.academicLevel`),
        program: t(`${prefix}.columns.program`),
        description: t(`${prefix}.columns.description`),
        dateOfAcquisition: t(`${prefix}.columns.dateOfAcquisition`),
        action: t(`${prefix}.columns.action`),
      },
    };
  }, [t]);

  const columns = useMemo<ColumnTable<MainStudy>[]>(
    () => [
      {
        headerText: texts.columns.academicLevel,
        columnName: 'academicLevel',
        tdClassName: 'text-center',
        thClassName: 'text-center',
      },
      {
        headerText: texts.columns.program,
        columnName: 'program',
        thClassName: 'text-center',
        tdClassName: 'text-center',
      },
      {
        headerText: texts.columns.dateOfAcquisition,
        columnName: 'graduationDate',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        cellFormat: (options: CellFormatOptions<MainStudy>) =>
          formatDate(options.row.graduationDate || '', 'DD/MM/YYYY'),
      },
    ],
    [texts],
  );

  return (
    <>
      <div className="w-100 mt-4">
        <SectionTitle text={texts.title} />
      </div>
      <div className="w-100 mt-4">
        <Table
          columns={columns}
          data={mainStudiesData}
          striped
          noResultsText={
            <TableEmptyContent
              title={texts.noRecords}
              subtitle={texts.noRecordsSubtitle}
            />
          }
        />
      </div>
    </>
  );
};
